import {FC} from 'react'
import {InputInterface} from './types'

const Radio: FC<InputInterface> = ({formik, name, label, value}) => {

  const fieldProps = formik.getFieldProps(name)

  // console.log({
  //   fieldProps,
  //   currentValue: value,
  //   label,
  // })

  return (
    <div className="form-check form-check-custom form-check-solid">
      <input type="radio"
             className="form-check-input"
             aria-checked={fieldProps.value === value}
             {...fieldProps}
             value={value || fieldProps.value}
             id={value}
             checked={fieldProps.value === value}

      />
      <label
        className={`form-check-label text-hover-gray-600 fs-7 fs-sm-5 p-2 ${fieldProps.value === value ? 'text-primary' : 'text-muted'}`}
        htmlFor={value}>
        {label}
      </label>
    </div>
  )
}

export {Radio}